import _ from 'lodash';
import Profile from 'common/domain/models/profile';

export default class TeamCalendarAssembler {
  buildListFromResponse(response) {
    const clonedResponse = _.cloneDeep(response);
    const requests = _.flatten(clonedResponse);
    return _.uniqBy(requests.map(this.buildFromRequest), 'userId');
  }

  buildFromRequest(request) {
    return new Profile(request.employeeId, request.name, request.image);
  }
}



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/assemblers/teamCalendar.assembler.js